import React from "react";
import OptimizedImage from "../OptimizedImage";

import {
  ButtonSize,
  ButtonVariant,
  Container,
  Content,
  IconImageContainer,
} from "./Button.styles";

export interface ButtonProps {
  label: string;
  type?: "submit" | "button";
  disabled?: boolean;
  variant?: ButtonVariant;
  size?: ButtonSize;
  icon?: Queries.SanityImage;
  iconAlt?: string;
  fullWidth?: boolean;
  onClick?: () => void;
}

const BUTTON_VARIANT_LEGACY_MAPPING = {
  // New
  primary: "primary",
  secondaryDark: "secondaryDark",
  secondaryLight: "secondaryLight",
  magic: "magic",
  ghostDark: "ghostDark",
  ghostLight: "ghostLight",
  outline: "outline",

  // Legacy
  dark: "secondaryLight",
  light: "secondaryDark",
  secondary: "secondaryLight",
  gradient: "magic",
  smokey: "secondaryLight",
};

const Button: React.FC<ButtonProps> = ({
  label,
  type,
  disabled,
  variant,
  size = "medium",
  icon,
  iconAlt,
  fullWidth,
  onClick,
}) => (
  <Container
    $variant={
      BUTTON_VARIANT_LEGACY_MAPPING[variant ?? "primary"] as ButtonVariant
    }
    $size={size}
    type={type}
    disabled={disabled}
    $fullWidth={fullWidth}
    $hasIcon={!!icon}
    onClick={onClick}
  >
    <Content>
      {icon && (
        <IconImageContainer>
          <OptimizedImage image={icon} alt={iconAlt} />
        </IconImageContainer>
      )}
      {label}
    </Content>
  </Container>
);

export default Button;
